import { Calendar } from 'primereact/calendar';
import styles from './ActivityLogs.module.css';
import AIEduButton from '../../components/Button/AIEduButton';
import AIEduDialog from '../../components/Dialog/AIEduDialog';
import { useIntl } from 'react-intl';

const ExportActivityLogs = ({
    visibleExport,
    startDate,
    endDate,
    maxEndDate,
    setStartDate,
    setEndDate,
    setMaxEndDate,
    setVisibleExport,
    handleExportActivityLogs,
}) => {
    const intl = useIntl();
    const { formatMessage: f } = intl;
    const handleStartDateChange = (e) => {
        const selectedStart = e.value;
        setStartDate(selectedStart);

        const newMaxEndDate = new Date(selectedStart);
        newMaxEndDate.setMonth(newMaxEndDate.getMonth() + 1);

        setMaxEndDate(
            new Date(Math.min(new Date().getTime(), newMaxEndDate.getTime()))
        );

        if (
            (endDate && endDate > newMaxEndDate) ||
            (selectedStart && selectedStart > endDate)
        ) {
            setEndDate(null);
        }
    };
    const hideExport = () => {
        if (!visibleExport) return;
        setStartDate(null);
        setEndDate(null);
        setMaxEndDate(null);
        setVisibleExport(false);
    };

    const exportTitle = () => (
        <div className='flex justify-content-between'>
            <div
                style={{
                    fontFamily: 'SamsungOne-800, sans-serif',
                    fontSize: '22px',
                }}
            >
                {f({ id: 'AI_EDU_EXPORT_ACTIVITY_LOG_IN_EXCEL' })}
            </div>
            <div>
                <i
                    style={{ cursor: 'pointer' }}
                    className='pi pi-times'
                    onClick={hideExport}
                />
            </div>
        </div>
    );

    return (
        <AIEduDialog
            visible={visibleExport}
            title={exportTitle}
            onHide={hideExport}
            style={{ width: '38rem' }}
            content={
                <div className='flex flex-column gap-5'>
                    <div className='flex gap-6'>
                        <div className='flex flex-column gap-2'>
                            <label
                                htmlFor='startDate'
                                style={{
                                    fontFamily: 'SamsungOne-600, sans-serif',
                                }}
                            >
                                {f({ id: 'AI_EDU_SELECT_START_DATE' })}
                            </label>
                            <Calendar
                                value={startDate}
                                onChange={handleStartDateChange}
                                showIcon
                                maxDate={new Date()}
                                className={styles.export_calendar}
                                id='startDate'
                                dateFormat='dd-mm-yy'
                                placeholder='DD-MM-YYYY'
                                icon='pi pi-calendar'
                                nextIcon='pi pi-arrow-right'
                                prevIcon='pi pi-arrow-left'
                            />
                            <span
                                style={{
                                    fontFamily: 'SamsungOne-500, sans-serif',
                                    fontSize: '14px',
                                }}
                            >
                                {f({ id: 'AI_EDU_MAX_DURATION_1_MONTH' })}
                            </span>
                        </div>
                        <div className='flex flex-column gap-2'>
                            <label
                                htmlFor='endDate'
                                style={{
                                    fontFamily: 'SamsungOne-600, sans-serif',
                                }}
                            >
                                {f({ id: 'AI_EDU_SELECT_END_DATE' })}
                            </label>
                            <Calendar
                                value={endDate}
                                minDate={startDate}
                                maxDate={maxEndDate}
                                onChange={(e) => setEndDate(e.value)}
                                showIcon
                                className={styles.export_calendar}
                                id='endDate'
                                dateFormat='dd-mm-yy'
                                placeholder='DD-MM-YYYY'
                                icon='pi pi-calendar'
                                nextIcon='pi pi-arrow-right'
                                prevIcon='pi pi-arrow-left'
                            />
                        </div>
                    </div>
                    <div className='flex justify-content-end'>
                        <AIEduButton
                            label={f({ id: 'AI_EDU_EXPORT' })}
                            className='btnPrimary'
                            disabled={!startDate || !endDate}
                            onClick={handleExportActivityLogs}
                        />
                    </div>
                </div>
            }
        />
    );
};

export default ExportActivityLogs;
